import React, {FC, Fragment} from 'react';
import messages from './messages';
import AppBarActions from 'components/VerticalLayout/app-bar-actions';
import Button from 'components/button';
import {FilterMap} from 'features/listing/list/slice/types';
import {MODAL} from 'features/modal-notch/constants';
import {Plus} from 'react-feather';
import {useTranslation} from 'react-i18next';
import {useDispatch} from 'react-redux';
import {CardBody, Row, Col, FormGroup} from 'reactstrap';
import showModal from 'store/ui/actions/show-modal';
import AsyncItemPicker from 'components/async-item-picker';
import {SubLocationFilters} from './types';
import Can from 'features/hylian-shield/can';

interface FilterProps {
  filters: FilterMap<SubLocationFilters>;
  onChangeFilters: (key: string, value: any) => void;
}

const FiltersSection: FC<FilterProps> = props => {
  const {t} = useTranslation();

  const {filters, onChangeFilters} = props;

  const dispatch = useDispatch();

  const handleCreate = () => {
    dispatch(showModal(MODAL.CREATE_STOCK_SUB_LOCATION));
  };

  return (
    <Fragment>
      <CardBody className="py-0">
        <Row className="mt-1">
          <Col lg="3" md="3">
            <FormGroup>
              <AsyncItemPicker
                endPoint="data/stock-locations"
                className="mb-1"
                label={t(...messages.location())}
                value={filters['filter[stock_location_id]']}
                onChange={o => onChangeFilters('filter[stock_location_id]', o)}
              />
            </FormGroup>
          </Col>
          <AppBarActions>
            <>
              <Can action="edit" subject="stock">
                <Button color="important" onClick={handleCreate}>
                  <Plus size={15} className="me-1" />
                  {t('stockLocationPage.addbtn')}
                </Button>
              </Can>
            </>
          </AppBarActions>
        </Row>
      </CardBody>
    </Fragment>
  );
};

export default FiltersSection;
